/* eslint-disable no-param-reassign */
import Phaser from 'phaser';
import { Images as ABCyaImages } from '@abcya/abcya_phaser';

export function addSprite(container, imageName, x, y, isCentered) {

  const sprite = ABCyaImages.addImage(0, 0, imageName, container).setOrigin(0);

  sprite.name = imageName;

  positionObject(sprite, x,y, isCentered);

  return sprite;
}

/**
 * 
 * @param {Phaser.GameObjects.Image} object 
 * @param {Number} x 
 * @param {Number} y 
 * @param {Boolean} isCentered 
 */
export function positionObject(object, x = null, y = null, isCentered = true) {
  if (x === null) {
    x = object.x;
    y = object.y;
  }
  if (isCentered && object.parentContainer) {

    if (object.originX === 0 && object.originY === 0) {

      const parentWidth = object.scene.scale.width;
      const parentHeight = object.scene.scale.height;

      // if 'isCentered' is true, x and y are offsets from center
      if (object.type === 'text') {
        object.x = parentWidth / 2 - 0 + x;
        object.y = parentHeight / 2 - 0 + y;
      }
      else {
        object.x = parentWidth / 2 - object.width / 2 + x;
        object.y = parentHeight / 2 - object.getBounds().height / 2 + y;
      }
    }
    else {
      object.x = x;
      object.y = y;
    }
  }
  else {
    object.x = x;
    object.y = y;
  }
}

export function addButton (container, name, x, y, isCentered, onClickFunction = () => {}) {
  const button = ABCyaImages.addImage(0, 0, name, container).setOrigin(0);
  button.setInteractive();
  button.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
    onClickFunction();
  });

  if (isCentered) positionObject(button, x,y, isCentered);
  else {
    button.setPosition(x, y);
    button.setOrigin(0.5);
  }

  return button;
}